import { ButtonsListContainer } from 'components/Button';
import { RMCustomButtonProps } from 'components/customComponents/CommonComponents/RMCustomButton/RMCustomButton';
import React from 'react';

interface Props {
  buttons: RMCustomButtonProps[];
  buttonsContainerStyle?: React.CSSProperties;
  containerClass?: string;
}
const PanelFooter = (props: Props) => {
  const { buttons, buttonsContainerStyle = {}, containerClass = '' } = props;

  return (
    <div id="panelfooter-button-lists-wrapper" className="h-[7%] items-center bg-white">
      <ButtonsListContainer
        buttonsList={buttons}
        containerStyleClass={`flex flex-row items-center w-full gap-[10px] pr-2 justify-end relative bottom-0 ${containerClass}`}
        containerStyle={buttonsContainerStyle}
      />
    </div>
  );
};

export default PanelFooter;
